import MainPage from './main';
import Edit from './edit';
import Import from './import';

const routes = [
    {
        path: '/*',
        Component: MainPage,
        props: {},
    },
    {
        path: '/:id/edit',
        Component: Edit,
        props: {},
    },
    {
        path: '/new',
        Component: Edit,
        props: {
            isNew: true,
        },
    },
    {
        path: '/import',
        Component: Import,
    },
];

export default routes;
